import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Use cdn for assets, this needs custom webpack loader with angular imports.
 *
 * Image used from CDN in CSS : https://cdn.nordnet.fr/images/logo-orange.png
 *
 */
/**
 * The Footer molecule contains the brand logo and links to others pages.
 * Under 767px wide, most links are not shown.
 *
 * @prop baseUrl The base Url. Used to build others Url in component.
 * @prop assistanceUrl The assistance website specific Url.
 * @prop acceoUrl The Acceo service specific Url.
 * @prop didomiUrl The Didomi script to launch Cookies modal.
 * @cssprop --icon-inline-font-size overrides font-size of icon-inline text.
 */
@customElement('nn-footer')
export class Footer extends LitElement {
  static styles = css`
    :host {
      background: var(--nn-black-85);
      border: 0;
      border-radius: 0;
      box-sizing: border-box;
      display: block;
      font-family: font-light;
      font-size: 16px;
      line-height: 1.35;
      margin: 0 auto;
      padding: 16px 0;
      width: 100%;
      position: relative;
      z-index: 1;
      --icon-inline-font-size: 0.8em;
    }
    * {
      box-sizing: border-box;
    }
    svg:not(:root) {
      overflow: hidden;
    }
    .container {
      margin: 0 auto;
      max-width: 1170px;
      padding: 0 15px;
      width: 100%;
    }
    a,
    a:focus,
    a:active,
    a:visited,
    a:hover {
      color: var(--nn-white);
      text-decoration: none;
    }
    .footer-reinsurance {
      align-items: center;
      background: var(--nn-black-85);
      color: var(--nn-white);
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .footer-reinsurance .text-line {
      text-transform: uppercase;
    }
    .footer-reinsurance .smaller {
      font-family: 'font-light';
      font-size: 0.875em;
      text-transform: none;
    }
    .phone-col .text-line {
      font-size: 1.1em;
    }
    .phone-col .smaller {
      display: inline;
    }
    .acceo-col .smaller {
      display: block;
      padding-top: 4px;
    }
    .footer-reinsurance .reinsurance-column {
      padding: 0 8px;
    }
    .footer-blocks {
      color: var(--nn-white);
      text-align: left;
    }
    .footer-blocks--content {
      align-items: flex-start;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .footer-blocks--content [class*='-col'] {
      padding-right: 10px;
    }
    .footer-title {
      font-family: 'font-heavy';
      font-size: 1.125em;
      margin: 25px 0 20px;
      text-transform: uppercase;
    }
    .footer-subtitle,
    .footer-subtitle:visited {
      color: #c0392b;
      display: inline-block;
      font-family: 'font-heavy';
      font-size: 0.875em;
      margin-bottom: 10px;
      text-transform: uppercase;
      transition: var(--nn-transition);
    }
    .footer-subtitle:hover {
      color: var(--nn-white);
    }
    .footer-blocks {
      align-items: flex-start;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .footer-blocks--container {
      flex-basis: auto;
      width: 37%;
      padding-right: 15px;
    }
    .footer-blocks--container:nth-child(2) {
      border-left: 1px solid rgba(190, 190, 190, 0.2);
      padding-left: 30px;
      margin-left: 15px;
      padding-bottom: 0;
      flex-basis: calc(62% - 15px);
      width: calc(50% - 15px);
    }
    .footer-blocks .link {
      color: var(--nn-black-35);
      display: inline-block;
      font-size: 0.75em;
      margin-bottom: 10px;
      padding-right: 15px;
      transition: 0.3s;
    }
    .footer-blocks .link:hover {
      color: var(--nn-white);
      text-decoration: underline;
    }
    .footer-blocks ul,
    .footer-blocks li {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    .connexion-col .resp-flex:nth-child(2) {
      margin-top: 15px;
    }
    .footer-bottom {
      flex-basis: 50%;
      margin-top: 0;
      width: 50%;
    }
    .footer-bottom .footer-bottom--content {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin: -35px -8px 30px;
      padding: 0;
      width: calc(100% + 16px);
    }
    .footer-bottom--content .link {
      background: none;
      border: 0;
      box-shadow: none;
      margin: 0;
      padding: 5px 8px;
      text-align: center;
    }
    .footer-bottom--content .separator {
      color: var(--nn-black-35);
      display: inline-block;
      flex-shrink: 0;
      font-size: 1em;
      height: auto;
      line-height: inherit;
      margin: 0;
      overflow: inherit;
      padding: 0;
      text-align: center;
      width: 3px;
      position: static;
    }
    .footer-blocks--content_second {
      width: 100%;
    }
    .footer-blocks--container:last-child .footer-blocks--content {
      flex-direction: column;
    }
    .footer-blocks--content_first__content,
    .footer-blocks--content_second__content {
      align-items: center;
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }
    .footer-blocks--content_first__content,
    .footer-blocks--content_second__content {
      align-items: flex-start;
    }
    .footer-blocks--content_second__content--left {
      flex-basis: auto;
      width: 33%;
    }
    .footer-blocks--content_second__content--right {
      flex-basis: auto;
      width: 67%;
    }
    .footer-category {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .footer-blocks--content_first__content--left .link {
      background: transparent
        url('https://cdn.nordnet.fr/images/logo-orange.png') no-repeat right
        bottom;
      display: block;
      height: 36px;
      padding: 5px 0 0;
      width: 163px;
    }
    .footer-social {
      align-items: center;
      display: flex;
      justify-content: flex-end;
      margin: 0;
    }
    .footer-social dt {
      color: var(--nn-black-35);
      font-size: 0.75em;
    }
    dd {
      align-items: center;
      display: inline-flex;
      margin: 0 0 0 20px;
    }
    .footer-social .picto {
      align-items: center;
      display: inline-flex;
      color: var(--nn-black-35);
      font-size: 1.35em;
    }
    .footer-social .picto {
      align-items: center;
      display: inline-flex;
      color: var(--nn-black-35);
      font-size: 1.35em;
    }
    .footer-social .picto svg path {
      transition: var(--nn-transition);
    }
    .footer-social .picto:hover svg path {
      fill: var(--nn-white);
    }
    .footer-blocks--content_second__content--left,
    .footer-blocks--content_second__content--right {
      margin-top: 12px;
    }
    .footer-blocks--content_second__content--left .category {
      margin-top: 35px;
      padding-right: 15px;
    }
    .footer-blocks--content_second__content--right .category {
      margin-top: 41px;
    }
    @media (max-width: 991px) {
      :host {
        padding-bottom: 30px;
      }
      .connexion-col .resp-flex:nth-child(2) {
        margin-top: 0;
      }
      .security-col .resp-flex:nth-child(2) {
        margin-top: 0;
      }
      .resp-flex {
        width: 100%;
      }
      .footer-social {
        margin-top: 20px !important;
      }
      .connexion-col,
      .security-col {
        display: flex;
        justify-content: space-around;
        width: 25%;
      }
      .security-col {
        width: 75%;
      }
      .footer-category {
        margin-top: 55px;
      }
      .footer-blocks--content {
        justify-content: space-between;
      }
      .footer-reinsurance {
        flex-wrap: wrap;
        margin-bottom: 20px;
      }
      .footer-reinsurance .reinsurance-column {
        flex-basis: auto;
        width: 25%;
      }
      .footer-reinsurance .logo-col {
        flex-shrink: 0;
        flex-basis: 100%;
        margin-bottom: 30px;
        text-align: center;
        width: 100%;
      }
      .footer-blocks--container {
        padding-right: 0;
      }
      .footer-blocks--container:last-child {
        border: 0;
        padding: 0;
        margin-left: 0;
      }
      .footer-blocks--content_first__content--left .link {
        width: 180px;
      }
      .footer-blocks {
        flex-direction: column;
      }
      .footer-blocks--container {
        border: 0;
        flex-basis: 100%;
        padding-left: 0;
        width: 100%;
      }
      .footer-blocks .footer-bottom--content {
        justify-content: center;
      }
      .footer-blocks .link,
      .footer-social dt {
        font-size: 0.9em;
      }
      .footer-blocks--content_second__content--right {
        display: flex;
        flex-wrap: wrap;
      }
      .footer-blocks--content_first__content--right {
        order: 2;
        flex-basis: 100%;
      }
      .footer-blocks--content_second__content--right .category {
        order: 1;
        margin-top: 15px;
      }
      .footer-blocks--container:nth-child(2) {
        border: 0;
        padding-left: 0;
        margin: 30px 0 0;
        padding-bottom: 0;
        flex-basis: 100%;
        width: 100%;
      }
      .footer-bottom {
        flex-basis: 100%;
        margin-top: 0;
        width: 100%;
      }
      .footer-blocks .footer-bottom--content {
        margin: 30px -8px 0;
      }
    }
    @media (max-width: 767px) {
      :host {
        padding: 0 0 30px;
      }
      .footer-blocks--container:first-child .footer-title,
      .footer-blocks--container:first-child .footer-blocks--content,
      .footer-reinsurance .logo-col,
      .footer-blocks--content_first__content--left {
        display: none;
      }
      .footer-reinsurance {
        flex-direction: column;
        justify-content: center;
        margin: 0 -15px 20px;
        width: calc(100% + 30px);
      }
      .footer-category {
        margin-top: 0;
      }
      .category-item:not(.mobile-visible) {
        display: none;
        margin: 0;
      }
      li.category-item {
        margin: 10px 0;
        display: inline-block;
        width: 100%;
      }
      .footer-blocks--content_second__content--left,
      .footer-blocks--content_second__content--right {
        flex-shrink: 0;
        width: 100%;
      }
      .footer-blocks--content_second__content--left .category {
        margin-top: 0;
        padding-right: 0;
      }
      .footer-blocks--content_second__content--left,
      .footer-blocks--content_second__content--right,
      .footer-blocks--content_second__content--right .category {
        margin-top: 0;
      }
      .footer-category,
      .footer-blocks--content_second__content {
        flex-direction: column;
        flex-wrap: wrap;
      }
      .footer-blocks--content_second__content--left,
      .footer-category {
        margin: 0;
      }
      .footer-blocks--container {
        flex-direction: column;
      }
      .footer-blocks--container:nth-child(2) {
        margin-top: 0px;
        order: 2;
      }
      .footer-reinsurance [class*='-column'] {
        border: 0;
        border-bottom: 1px solid var(--nn-white);
        display: flex;
        padding: 23px 0;
        width: 100%;
        justify-content: center;
        align-items: center;
      }
      .footer-reinsurance .logo-col {
        display: none;
      }
      .footer-reinsurance .acceo-col,
      .footer-reinsurance .phone-col {
        width: auto;
      }
      .footer-blocks {
        display: flex;
        flex-direction: column;
      }
      .footer-blocks .footer-bottom--content {
        margin: 0 -8px 40px;
      }
      .footer-blocks--container,
      .footer-blocks--content_first__content--right {
        border: 0;
        flex-basis: 100%;
        padding: 0;
        text-align: center;
        width: 100%;
      }
      .footer-blocks--content_second__content--right {
        flex-basis: 100%;
      }
      .footer-blocks--content_first__content--right {
        justify-content: center;
      }
      .footer-blocks .link,
      .footer-social dt {
        font-size: 1em;
      }
      .footer-blocks .footer-bottom--content {
        margin: 0 0 10px;
        flex-direction: column;
        width: 100%;
      }
      .footer-blocks .footer-bottom--content .separator {
        display: none;
      }
      .footer-social {
        display: inline-flex;
      }
      .footer-social .picto {
        color: var(--nn-black-35);
        font-size: 1.75em;
      }
      .footer-bottom {
        flex-basis: 100%;
        width: 100%;
        order: 1;
      }
      .facebook svg {
        height: 28px;
        width: 16px;
      }
      .twitter svg {
        height: 31px;
        width: 28px;
      }
      .youtube svg {
        height: 31px;
        width: 31px;
      }
    }
  `;

  @property({ type: String }) baseUrl = 'https://www.nordnet.com';

  @property({ type: String }) assistanceUrl = 'https://assistance.nordnet.com';

  @property({ type: String }) acceoUrl = 'https://www.acce-o.fr/client/nordnet';

  @property({ type: String }) didomiUrl = '';
  // javascript:Didomi.preferences.show()

  render() {
    return html`
      <footer id="global-footer" class="global-footer">
        <div class="container">
          <div class="footer-reinsurance">
            <div class="reinsurance-column logo-col">
              <a
                id="footer-logo-nordnet"
                title="Nordnet"
                href="${this.baseUrl}"
              >
                <svg
                  class="img-responsive"
                  width="155"
                  height="28"
                  viewBox="0 0 170 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Nordnet</title>
                  <path
                    d="M111.032 5.26732C111.032 5.26732 111.014 5.26732 111.032 5.26732C109.213 5.34022 107.754 6.05103 106.962 6.7254C106.944 6.7254 106.926 6.74362 106.908 6.74362C106.53 7.03524 106.296 6.7983 106.296 6.50668V5.8141H100.984V29.7084H106.314V14.1069C106.314 11.4824 108.403 9.36817 110.996 9.36817C113.553 9.36817 115.605 11.4277 115.677 13.9976C115.677 14.034 115.677 14.0705 115.677 14.1069V14.1252V29.7084H121.26V13.6695C121.26 7.14459 116.596 4.81167 111.032 5.26732Z"
                    fill="white"
                  ></path>
                  <path
                    d="M20.9062 5.26732C19.0875 5.34022 17.6289 6.05103 16.8366 6.7254C16.8186 6.7254 16.8006 6.74362 16.7826 6.74362C16.4045 7.03524 16.1704 6.7983 16.1704 6.50668V5.8141H10.8763V29.7084H16.2064V14.1069C16.2064 11.4824 18.2952 9.36817 20.8882 9.36817C23.4452 9.36817 25.498 11.4277 25.5701 13.9976C25.5701 14.034 25.5701 14.0705 25.5701 14.1069V14.1252V29.7084H31.1522V13.6695C31.1342 7.14459 26.4704 4.81167 20.9062 5.26732Z"
                    fill="white"
                  ></path>
                  <path
                    d="M64.6094 8.6209C64.5554 8.67558 64.4653 8.74849 64.3753 8.74849C64.2312 8.74849 64.1052 8.63913 64.0872 8.51155V5.8141H58.7751V29.7266H64.0872V21.3791C64.0872 13.469 67.0943 10.3159 72.1903 10.3159H72.9647V5.21264H71.7582C68.4629 5.19441 66.3741 6.16039 64.6094 8.6209Z"
                    fill="white"
                  ></path>
                  <path
                    d="M44.9637 5.21263C38.211 5.21263 32.7189 10.7533 32.7189 17.6063C32.7189 24.4411 38.193 30 44.9637 30C51.7163 30 57.1905 24.4593 57.1905 17.6063C57.1905 10.7533 51.7163 5.21263 44.9637 5.21263ZM44.9457 25.079C40.8581 25.079 37.5448 21.7254 37.5448 17.5881C37.5448 13.4508 40.8581 10.0972 44.9457 10.0972C49.0333 10.0972 52.3466 13.4508 52.3466 17.5881C52.3466 21.7436 49.0333 25.079 44.9457 25.079Z"
                    fill="white"
                  ></path>
                  <path
                    d="M92.5203 7.07169C92.5203 7.25395 92.3763 7.38153 92.2142 7.38153C92.1962 7.38153 92.1782 7.38153 92.1602 7.3633C90.1794 5.97813 87.8025 5.17618 85.2275 5.17618C78.7809 5.17618 73.5049 10.2248 73.0187 16.6221C73.0187 16.6586 73.0187 16.695 73.0007 16.7497C73.0007 16.7679 73.0007 16.7861 73.0007 16.8044C72.9827 16.9502 72.9827 17.1142 72.9827 17.26C72.9827 17.3329 72.9827 17.4058 72.9827 17.497C72.9827 17.5152 72.9827 17.5516 72.9827 17.5699C72.9827 17.6428 72.9827 17.7339 72.9827 17.8068C72.9827 17.9344 72.9827 18.062 73.0007 18.1713C73.0007 18.2078 73.0007 18.2625 73.0007 18.2989C73.3608 24.8056 78.6909 29.9818 85.2095 29.9818C87.7305 29.9818 90.0714 29.2163 92.0341 27.8858C92.0341 27.8858 92.1602 27.8311 92.2142 27.8311C92.3763 27.8311 92.5203 27.9769 92.5203 28.1409V29.7266H97.8504V0H92.5203V7.07169ZM85.1554 25.0243C84.021 25.0243 82.9406 24.7691 81.9862 24.3135C79.5192 23.0923 77.8086 20.5407 77.8086 17.5699C77.8086 13.4326 81.1219 10.079 85.2095 10.079C86.3439 10.079 87.4243 10.3341 88.3787 10.7898C90.8457 12.0109 92.5563 14.5626 92.5563 17.5334C92.5563 21.6707 89.243 25.0243 85.1554 25.0243Z"
                    fill="white"
                  ></path>
                  <path
                    d="M144.669 9.84204C142.418 7.01701 138.997 5.21263 135.143 5.21263C128.39 5.21263 122.898 10.7533 122.898 17.6063C122.898 17.9526 122.916 18.2989 122.934 18.627C123.15 18.8821 123.366 19.1555 123.583 19.3925C126.284 22.8372 130.443 25.0243 135.125 25.0243C131.073 25.0243 127.796 21.7072 127.796 17.6063C127.796 13.5055 131.073 10.1883 135.125 10.1883C137.142 10.1883 138.979 11.0267 140.311 12.3572C139.303 12.74 129.201 16.4581 129.201 16.4581C130.245 17.825 131.524 19.0462 133.018 20.0486L147.064 14.9089C146.668 13.0134 145.821 11.3001 144.669 9.84204Z"
                    fill="white"
                  ></path>
                  <path
                    d="M146.686 19.3742C143.985 22.8189 139.825 25.0243 135.143 25.0243C130.461 25.0243 126.302 22.8372 123.601 19.3925C123.366 19.1373 123.15 18.8821 122.952 18.627C123.474 24.9878 128.733 29.9818 135.143 29.9818C141.554 29.9818 146.83 24.9696 147.334 18.6087C147.118 18.8821 146.902 19.1373 146.686 19.3742Z"
                    fill="#f00"
                  ></path>
                  <path
                    d="M2.77309 29.9818C1.24249 29.9818 0 28.7242 0 27.175C0 25.6258 1.24249 24.3682 2.77309 24.3682C4.30369 24.3682 5.54618 25.6258 5.54618 27.175C5.54618 28.7242 4.30369 29.9818 2.77309 29.9818Z"
                    fill="white"
                  ></path>
                  <path
                    d="M164.333 27.175C164.333 25.6258 165.575 24.3682 167.106 24.3682C168.636 24.3682 169.879 25.6258 169.879 27.175C169.879 28.7242 168.636 29.9818 167.106 29.9818C165.575 29.9818 164.333 28.7242 164.333 27.175Z"
                    fill="white"
                  ></path>
                  <path
                    d="M159.038 24.5869L156.968 24.5687C155.527 24.5687 154.357 23.384 154.375 21.9259V10.6258C154.375 10.48 154.501 10.3706 154.645 10.3524H159.038V5.21265H154.663C154.519 5.21265 154.393 5.08506 154.375 4.93926V0.0182343H149.063V19.8664V22.1993V22.2175C149.063 26.9198 152.196 29.9818 156.716 29.9818H159.02V29.9636H159.038V24.5869Z"
                    fill="white"
                  ></path>
                </svg>
              </a>
            </div>
            <div class="reinsurance-column">
              <nn-icon-inline id="footer-call-by-phone" class="phone-col">
                <svg
                  slot="icon"
                  class="img-responsive"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                >
                  <path
                    d="M6.26243 5.89348C6.63957 5.51649 6.73386 4.90387 6.451 4.38551L4.75388 0.709831C4.61245 0.379962 4.32959 0.144341 3.99959 0.0500929L3.85815 0.00296956C3.43387 -0.0441545 2.30245 0.474211 1.12388 1.2282C0.0867438 1.84081 0.0867424 2.54767 0.0395997 2.78329C-0.101828 3.82002 0.181029 5.32799 0.181029 5.32799C0.558171 7.40145 1.50103 9.56916 3.33959 12.2552L3.62244 12.6793C4.75386 14.3287 5.83815 15.6953 6.96957 16.8263C7.72386 17.5331 8.431 18.1457 9.13814 18.6641C9.93956 19.2296 10.7881 19.6537 11.5896 19.9365C11.6367 19.9365 11.731 19.9836 11.7781 19.9836C12.2024 20.0307 12.6267 19.9836 13.0038 19.748C13.1453 19.6537 13.2867 19.5595 13.381 19.4652C14.6067 18.617 15.4553 17.7687 15.5967 17.3918C15.7381 17.0148 15.5967 16.5906 15.3138 16.3079L14.7953 15.7895L13.5695 14.5643L12.7681 13.7632L12.4853 13.4805C12.2967 13.2448 12.061 13.1035 11.7781 13.0563C11.5424 13.0092 11.2596 13.0092 11.0238 13.1035L8.90242 13.8103L8.66671 13.5276C7.86529 12.5851 6.92243 11.1714 6.92243 11.1714C6.92243 11.1714 6.49815 10.5116 6.02672 9.75765C5.64958 9.14504 5.2253 8.43818 4.94244 7.91981L4.80101 7.63707L6.26243 5.89348Z"
                    fill="white"
                  />
                </svg>
                <div slot="text">
                  <b class="text-line">3420</b>
                  <span class="smaller"
                    >(service gratuit +&nbsp;prix d'appel)</span
                  >
                </div>
              </nn-icon-inline>
            </div>
            <a
              id="footer-acceo-link"
              class="reinsurance-column"
              href="${this.acceoUrl}"
              target="_blank"
              rel="nofollow noopener"
              title="Acceo"
            >
              <nn-icon-inline class="acceo-col">
                <svg
                  slot="icon"
                  class="img-responsive"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Acceo</title>
                  <path
                    d="M25.5696 0.401768C25.8565 0.688745 26 1.03312 26 1.43489C26 1.83665 25.8565 2.18103 25.5696 2.468L22.011 6.05522C21.7241 6.3422 21.3892 6.48569 21.0066 6.48569C20.6048 6.48569 20.2604 6.3422 19.9735 6.05522C19.6865 5.76824 19.5431 5.42387 19.5431 5.0221C19.5431 4.6012 19.6865 4.25683 19.9735 3.98898L23.532 0.401768C23.7999 0.133923 24.1395 0 24.5509 0C24.962 0 25.3016 0.133923 25.5696 0.401768ZM7.80568 16.2429C8.07352 15.9751 8.41311 15.8413 8.82445 15.8413C9.23578 15.8413 9.57537 15.9751 9.84322 16.2429C10.1302 16.5299 10.2737 16.8744 10.2737 17.276C10.2737 17.7161 10.1302 18.0605 9.84322 18.3092L3.35753 24.8522C3.07055 25.1392 2.73575 25.2827 2.35311 25.2827C1.95134 25.2827 1.60697 25.1392 1.31999 24.8522C1.03302 24.5653 0.889526 24.2209 0.889526 23.8191C0.889526 23.3982 1.03302 23.0538 1.31999 22.786L7.80568 16.2429ZM14.0618 11.4791C14.0618 10.9817 13.885 10.5512 13.5309 10.1877C13.1769 9.82419 12.7417 9.64244 12.2251 9.64244C11.7277 9.64244 11.2972 9.82419 10.9337 10.1877C10.5702 10.5512 10.3885 10.9817 10.3885 11.4791C10.3885 11.8043 10.2832 12.0722 10.0728 12.2826C9.86235 12.4931 9.60407 12.5983 9.29796 12.5983C8.99185 12.5983 8.73357 12.4931 8.52312 12.2826C8.31267 12.0722 8.20745 11.8043 8.20745 11.4791C8.20745 10.9243 8.31267 10.3981 8.52312 9.90072C8.73357 9.40329 9.02055 8.97282 9.38405 8.60932C9.74756 8.24581 10.1732 7.95884 10.6611 7.74839C11.149 7.53794 11.6703 7.43271 12.2251 7.43271C12.78 7.43271 13.3013 7.53794 13.7892 7.74839C14.2769 7.95884 14.7026 8.24581 15.0661 8.60932C15.4296 8.97282 15.7165 9.40329 15.927 9.90072C16.1374 10.3981 16.2426 10.9243 16.2426 11.4791C16.2426 11.8043 16.1374 12.0722 15.927 12.2826C15.7165 12.4931 15.4583 12.5983 15.1522 12.5983C14.8462 12.5983 14.5878 12.4931 14.3775 12.2826C14.167 12.0722 14.0618 11.8043 14.0618 11.4791ZM12.2251 3.18545C13.3348 3.18545 14.3775 3.3959 15.3532 3.8168C16.329 4.2377 17.1803 4.81644 17.9073 5.55301C18.6343 6.28959 19.2083 7.15052 19.6293 8.13581C20.0502 9.12109 20.2606 10.1686 20.2606 11.2782C20.2606 12.2348 20.0981 13.1723 19.7728 14.0906C19.7346 14.1862 19.6963 14.2532 19.658 14.2915C19.4477 14.6931 19.2371 15.0662 19.0266 15.4105C18.8353 15.7166 18.6297 16.0371 18.4097 16.372C18.1898 16.7069 17.9841 16.9889 17.7928 17.2186C17.7546 17.276 17.7067 17.3334 17.6492 17.3908C17.5917 17.4482 17.5344 17.5152 17.477 17.5917C17.2091 17.8977 17.013 18.1609 16.8887 18.3809C16.7643 18.6008 16.7117 18.9596 16.7309 19.457C16.7691 20.49 16.7787 21.2505 16.7595 21.7384C16.7404 22.2262 16.7022 22.6137 16.6448 22.9006C16.4726 23.8955 16.0373 24.6608 15.339 25.1965C14.6406 25.7322 13.6697 26 12.4262 26H12.3688C12.0244 26 11.7278 25.8758 11.4791 25.6269C11.2304 25.3782 11.0965 25.0721 11.0774 24.7086C11.0582 24.5364 11.0821 24.3692 11.1491 24.2064C11.2161 24.0438 11.3069 23.9051 11.4217 23.7903C11.6704 23.5033 11.9766 23.3598 12.3401 23.3598C12.7418 23.3407 13.0527 23.3024 13.2727 23.245C13.4928 23.1876 13.6602 23.1208 13.7749 23.0442C13.8897 22.9676 13.9615 22.8864 13.9902 22.8003C14.0189 22.7143 14.0428 22.6234 14.0619 22.5277L14.0906 22.3842C14.1287 22.1738 14.148 21.8007 14.148 21.265C14.148 20.7293 14.1384 20.1458 14.1195 19.5145C14.1003 19.017 14.1338 18.5818 14.2199 18.2087C14.3059 17.8356 14.4161 17.5056 14.5499 17.2186C14.6838 16.9317 14.8369 16.6782 15.009 16.4581C15.1812 16.2381 15.3534 16.0325 15.5256 15.8411C15.5831 15.7836 15.6692 15.6785 15.784 15.5255C15.8987 15.3916 16.0279 15.2146 16.1715 14.9947C16.3149 14.7747 16.4632 14.545 16.6162 14.3059C16.7694 14.0668 16.908 13.8372 17.0323 13.6172C17.1566 13.3972 17.2666 13.2105 17.3623 13.0575C17.458 12.7896 17.5297 12.5074 17.5776 12.2109C17.6254 11.9143 17.6493 11.6034 17.6493 11.2782C17.6493 10.5321 17.5057 9.82419 17.2188 9.15458C16.9318 8.48496 16.5444 7.90622 16.0565 7.41836C15.5686 6.9305 14.9947 6.54308 14.3347 6.2561C13.6746 5.96913 12.9715 5.82564 12.2254 5.82564C11.4793 5.82564 10.7762 5.96913 10.1161 6.2561C9.45608 6.54308 8.88213 6.9305 8.39426 7.41836C7.9064 7.90622 7.51898 8.48496 7.23201 9.15458C6.94503 9.82419 6.80154 10.5321 6.80154 11.2782C6.80154 11.6417 6.67718 11.9526 6.42847 12.2109C6.17976 12.4692 5.87365 12.5983 5.51014 12.5983C5.14664 12.5983 4.83575 12.4692 4.57747 12.2109C4.31919 11.9526 4.19005 11.6417 4.19005 11.2782C4.19005 10.1686 4.4005 9.12109 4.8214 8.13581C5.2423 7.15052 5.81625 6.28959 6.54326 5.55301C7.27027 4.81644 8.12163 4.2377 9.09736 3.8168C10.0728 3.3959 11.1155 3.18545 12.2251 3.18545Z"
                    fill="white"
                  ></path>
                </svg>
                <span slot="text">
                  <b class="text-line"> Sourd ou malentendant&nbsp;? </b>
                  <span class="smaller"> Contactez-nous avec ACCEO </span>
                </span>
              </nn-icon-inline>
            </a>
            <a
              id="footer-assistance-link"
              class="reinsurance-column"
              href="${this.assistanceUrl}"
              target="_blank"
              rel="noopener"
              title="Assistance"
            >
              <nn-icon-inline class="contact-col">
                <svg
                  slot="icon"
                  class="img-responsive"
                  width="21"
                  height="21"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Aide - Assistance</title>
                  <path
                    d="M5.35827 1.60402L6.66132 4.80328C5.7239 5.29355 4.95876 6.05868 4.46849 6.99609L1.26919 5.69304C2.11709 3.89731 3.56251 2.45191 5.35827 1.60402ZM5.59651 1.00598C4.48945 1.45851 3.48369 2.12715 2.63801 2.97282C1.79232 3.8185 1.12368 4.82424 0.671143 5.93129L4.69701 7.57954C4.93051 7.00654 5.27618 6.48599 5.7137 6.04848C6.15123 5.61096 6.67178 5.2653 7.24478 5.0318L5.59651 1.00598Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M12.6418 1.60402C14.4375 2.45191 15.8829 3.89731 16.7308 5.69304L13.5315 6.99609C13.0413 6.05868 12.2761 5.29355 11.3387 4.80328L12.6418 1.60402ZM12.4035 1.00598L10.7552 5.0318C11.3283 5.2653 11.8488 5.61096 12.2863 6.04848C12.7239 6.48599 13.0695 7.00654 13.303 7.57954L17.3289 5.93129C16.8764 4.82424 16.2077 3.8185 15.362 2.97282C14.5163 2.12715 13.5106 1.45851 12.4035 1.00598Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M4.46849 11.6732C4.95876 12.6106 5.7239 13.3757 6.66132 13.866L5.35827 17.0652C3.56251 16.2173 2.11709 14.7719 1.26919 12.9762L4.46849 11.6732ZM4.69701 11.0897L0.671143 12.738C1.12368 13.845 1.79232 14.8508 2.63801 15.6964C3.48369 16.5421 4.48945 17.2107 5.59651 17.6633L7.24478 13.6375C6.67178 13.404 6.15123 13.0583 5.7137 12.6208C5.27618 12.1833 4.93051 11.6627 4.69701 11.0897Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M13.5315 11.6732L16.7308 12.9762C15.8829 14.7719 14.4375 16.2173 12.6418 17.0652L11.3387 13.866C12.2761 13.3757 13.0413 12.6106 13.5315 11.6732ZM13.303 11.0897C13.0695 11.6627 12.7239 12.1833 12.2863 12.6208C11.8488 13.0583 11.3283 13.404 10.7552 13.6375L12.4035 17.6633C13.5106 17.2107 14.5163 16.5421 15.362 15.6964C16.2077 14.8508 16.8764 13.845 17.3289 12.738L13.303 11.0897Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M8.99995 13.9827C8.39785 13.9842 7.80137 13.8669 7.24471 13.6375L5.59644 17.6633C7.77722 18.5581 10.2227 18.5581 12.4035 17.6633L10.7552 13.6375C10.1985 13.8669 9.60204 13.9842 8.99995 13.9827Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M8.99995 4.68607C9.60204 4.68453 10.1985 4.80184 10.7552 5.03128L12.4035 1.00546C10.2227 0.110647 7.77722 0.110647 5.59644 1.00546L7.24471 5.03128C7.80137 4.80184 8.39785 4.68453 8.99995 4.68607Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M13.303 7.5794C13.7634 8.70426 13.7634 9.96498 13.303 11.0898L17.3288 12.7381C18.2237 10.5573 18.2237 8.11191 17.3288 5.93115L13.303 7.5794Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M4.35177 9.33462C4.35023 8.73253 4.46755 8.13606 4.69699 7.5794L0.67112 5.93115C-0.223707 8.11191 -0.223707 10.5573 0.67112 12.7381L4.69699 11.0898C4.46755 10.5332 4.35023 9.93671 4.35177 9.33462Z"
                    fill="#fff"
                  ></path>
                </svg>
                <span slot="text">
                  <span class="text-line"> Aide/Assistance </span>
                </span>
              </nn-icon-inline>
            </a>
            <a
              id="footer-contact-link"
              class="reinsurance-column"
              href="${this.baseUrl}/contactez-nous?reset=all"
              title="Contactez-nous"
            >
              <nn-icon-inline>
                <svg
                  slot="icon"
                  class="img-responsive"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <title>Contactez-nous</title>
                  <path
                    d="M18.1818 6.36297C18.664 6.36297 19.1265 6.55454 19.4675 6.89553C19.8084 7.23652 20 7.699 20 8.18124V11.8178C20 12.3 19.8084 12.7625 19.4675 13.1035C19.1265 13.4445 18.664 13.6361 18.1818 13.6361H17.2164C16.9947 15.3937 16.1393 17.01 14.8107 18.1817C13.482 19.3534 11.7715 20 10 20V18.1817C11.4466 18.1817 12.834 17.607 13.8569 16.5841C14.8799 15.5611 15.4545 14.1736 15.4545 12.7269V7.2721C15.4545 5.8254 14.8799 4.43795 13.8569 3.41497C12.834 2.39199 11.4466 1.81729 10 1.81729C8.55336 1.81729 7.16598 2.39199 6.14305 3.41497C5.12013 4.43795 4.54545 5.8254 4.54545 7.2721V13.6361H1.81818C1.33597 13.6361 0.873508 13.4445 0.532533 13.1035C0.191558 12.7625 0 12.3 0 11.8178V8.18124C0 7.699 0.191558 7.23652 0.532533 6.89553C0.873508 6.55454 1.33597 6.36297 1.81818 6.36297H2.78364C3.00548 4.60552 3.86098 2.98942 5.18961 1.81791C6.51824 0.646398 8.22869 0 10 0C11.7713 0 13.4818 0.646398 14.8104 1.81791C16.139 2.98942 16.9945 4.60552 17.2164 6.36297H18.1818ZM6.14545 13.4406L7.10909 11.8987C7.97552 12.4415 8.97761 12.7286 10 12.7269C11.0224 12.7286 12.0245 12.4415 12.8909 11.8987L13.8545 13.4406C12.6993 14.1644 11.3632 14.5473 10 14.5452C8.63678 14.5473 7.30067 14.1644 6.14545 13.4406Z"
                    fill="white"
                  />
                </svg>
                <span slot="text">
                  <span class="text-line"> Contactez-nous </span>
                </span>
              </nn-icon-inline>
            </a>
          </div>
          <div class="footer-blocks">
            <div class="footer-blocks--container">
              <div class="footer-title">Nos Offres</div>
              <div class="footer-blocks--content">
                <div class="connexion-col">
                  <div class="resp-flex">
                    <div class="links-title">
                      <a
                        class="footer-subtitle"
                        id="footer-internet"
                        title="Découvrez notre gamme Connexion Internet"
                        href="${this.baseUrl}/connexion-internet"
                      >
                        Accès internet
                      </a>
                    </div>
                    <ul class="category">
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-satellite"
                          title="Internet Satellite neosat"
                          href="${this
                            .baseUrl}/connexion-internet/internet-satellite"
                        >
                          Internet Satellite neosat
                        </a>
                      </li>
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-satellite-pro"
                          title="Internet Satellite neosat pro"
                          href="${this
                            .baseUrl}/connexion-internet/internet-satellite-pro"
                        >
                          Internet Satellite neosat pro
                        </a>
                      </li>
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-fibre"
                          title="Internet Fibre"
                          href="${this
                            .baseUrl}/connexion-internet/internet-fibre"
                        >
                          Internet Fibre
                        </a>
                      </li>
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-adsl"
                          title="Internet ADSL"
                          href="${this
                            .baseUrl}/connexion-internet/internet-adsl"
                        >
                          Internet ADSL
                        </a>
                      </li>
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-4gfix"
                          title="Internet 4GFIX"
                          href="${this.baseUrl}/connexion-internet/internet-4g"
                        >
                          Internet 4GFIX
                        </a>
                      </li>
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-radio"
                          title="Internet Radio MISTRAL"
                          href="${this
                            .baseUrl}/connexion-internet/internet-radio"
                        >
                          Internet Radio MISTRAL
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="security-col">
                  <div class="resp-flex">
                    <div class="links-title">
                      <a
                        id="footer-mobile-link"
                        class="footer-subtitle"
                        title="Découvrez notre gamme Mobile"
                        href="${this.baseUrl}/forfaits-mobile"
                      >
                        Mobile
                      </a>
                    </div>
                    <ul class="category">
                      <li class="category-item">
                        <a
                          id="footer-forfaits-mobile-link"
                          class="link"
                          title="Forfaits Mobile"
                          href="${this.baseUrl}/forfaits-mobile"
                        >
                          Forfaits Mobile
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="resp-flex">
                    <div class="links-title">
                      <a
                        class="footer-subtitle"
                        id="footer-VPN"
                        title="Découvrez nos solutions de sécurité Internet"
                        href="${this.baseUrl}/connexion-internet/securite"
                      >
                        Antivirus & VPN
                      </a>
                    </div>
                    <ul class="category">
                      <li class="category-item">
                        <a
                          class="link"
                          title="Securitoo Antivirus"
                          id="footer-securitoo-antivirus"
                          href="${this.baseUrl}/securite/securitoo-antivirus"
                        >
                          Securitoo Antivirus
                        </a>
                      </li>
                      <li class="category-item">
                        <a
                          class="link"
                          title="Securitoo Freedome"
                          id="footer-securitoo-freedome"
                          href="${this.baseUrl}/securite/securitoo-freedome"
                        >
                          Securitoo Freedome
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="resp-flex">
                    <div class="links-title">
                      <a
                        class="footer-subtitle"
                        id="footer-domaine"
                        title="Réservez votre nom de domaine chez Nordnet"
                        href="${this.baseUrl}/nom-de-domaine"
                      >
                        Noms de domaine
                      </a>
                    </div>
                    <ul class="category">
                      <li class="category-item">
                        <a
                          class="link"
                          id="footer-relais"
                          title="Pack Relais Domaine"
                          href="${this.baseUrl}/nom-de-domaine"
                        >
                          Pack Relais Domaine
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-blocks--container">
              <div class="footer-blocks--content">
                <div class="footer-blocks--content_second">
                  <div class="footer-blocks--content_second__content">
                    <div class="footer-blocks--content_second__content--left">
                      <div class="footer-blocks--content_first__content--left">
                        <a
                          class="link"
                          title="Qui sommes-nous ?"
                          id="footer-who"
                          href="${this.baseUrl}/corporate/qui-sommes-nous"
                        >
                          Qui sommes-nous&nbsp;?
                        </a>
                      </div>
                      <ul class="category">
                        <li class="category-item">
                          <a
                            class="link"
                            title="Blog"
                            id="footer-blog"
                            href="https://blog.nordnet.com"
                            target="_blank"
                            rel="noopener"
                          >
                            Blog
                          </a>
                        </li>
                        <li class="category-item">
                          <a
                            class="link"
                            title="Recrutement"
                            id="footer-recrutement"
                            href="${this.baseUrl}/recrutement"
                          >
                            Recrutement
                          </a>
                        </li>
                        <li class="category-item">
                          <a
                            class="link"
                            id="footer-partenaire"
                            rel="noopener"
                            title="Devenez partenaire"
                            target="_blank"
                            href="https://partenaires.nordnet.com"
                          >
                            Devenez partenaire
                          </a>
                        </li>
                        <li class="category-item">
                          <a
                            class="link"
                            title="Espace Presse"
                            id="footer-presse"
                            href="${this.baseUrl}/espace-presse"
                          >
                            Espace Presse
                          </a>
                        </li>
                        <li class="category-item">
                          <a
                            class="link"
                            title="Guides"
                            id="footer-guides"
                            href="${this.baseUrl}/guides"
                          >
                            Guides
                          </a>
                        </li>
                        <li class="category-item">
                          <a
                            class="link"
                            title="Téléchargements"
                            id="footer-telechargements"
                            href="${this.assistanceUrl}/telechargement"
                          >
                            Téléchargements
                          </a>
                        </li>
                        <li class="category-item mobile-visible">
                          <a
                            class="link"
                            id="footer-tarifs"
                            title="Nos tarifs"
                            href="${this.baseUrl}/corporate/tarifs"
                          >
                            Nos tarifs
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="footer-blocks--content_second__content--right">
                      <div class="footer-blocks--content_first__content--right">
                        <dl class="footer-social">
                          <dt class="dt-title">Retrouvez-nous</dt>
                          <dd class="facebook">
                            <a
                              class="picto"
                              title="Nordnet sur Facebook"
                              id="footer-facebook"
                              href="https://www.facebook.com/NordNetOFFICIEL"
                              target="_blank"
                              rel="noopener"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="21"
                                viewBox="0 0 8 14"
                                fill="none"
                              >
                                <title>Nordnet sur Facebook</title>
                                <path
                                  d="M4.14325 13.3565V7.11474H6.71437L7.1206 5.04627H4.14325V4.00909C4.14325 3.46936 4.36414 2.95419 5.33124 2.95419H7.26416V0.889648H4.52001C2.21275 0.889648 1.58315 2.10672 1.58315 3.79379V5.04532H0V7.11474H1.58315V13.3565H4.14325Z"
                                  fill="#BEBEBE"
                                />
                              </svg>
                            </a>
                          </dd>
                          <dd class="twitter">
                            <a
                              class="picto"
                              title="Nordnet sur Twitter"
                              id="footer-twitter"
                              href="https://twitter.com/NordNetOFFICIEL"
                              target="_blank"
                              rel="noopener"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23"
                                height="23"
                                viewBox="0 0 15 11"
                                fill="none"
                              >
                                <title>Nordnet sur Twitter</title>
                                <path
                                  d="M13.3208 2.97338C13.3208 2.86425 13.3183 2.75611 13.3122 2.64895C13.8952 2.30092 14.4008 1.86541 14.8009 1.36696C14.2658 1.55967 13.6914 1.68846 13.0876 1.74249C13.7037 1.4387 14.1762 0.953045 14.3996 0.370061C13.8227 0.650244 13.1846 0.850804 12.5058 0.955025C11.9622 0.459509 11.1865 0.143949 10.3286 0.132145C8.68162 0.110517 7.34635 1.22538 7.34635 2.62238C7.34635 2.82096 7.37212 3.01367 7.42365 3.19946C4.94334 3.07167 2.7453 2.03741 1.27499 0.478205C1.01848 0.851794 0.871219 1.28829 0.871219 1.75628C0.871219 2.64111 1.39772 3.42759 2.19789 3.89161C1.70822 3.87394 1.24922 3.75499 0.846689 3.56029C0.846689 3.57111 0.846689 3.58192 0.846689 3.59273C0.846689 4.82953 1.87516 5.86573 3.23986 6.10756C2.98949 6.16457 2.72562 6.19408 2.45439 6.19312C2.26173 6.19213 2.07515 6.17542 1.89352 6.14393C2.27275 7.15754 3.37486 7.89783 4.67943 7.92239C3.65832 8.60073 2.37215 9.00577 0.975513 9.00284C0.734939 9.00284 0.496879 8.99008 0.263672 8.96647C1.58425 9.69202 3.15145 10.1147 4.83649 10.1147C10.3213 10.1158 13.3208 6.29141 13.3208 2.97338Z"
                                  fill="#BEBEBE"
                                />
                              </svg>
                            </a>
                          </dd>
                          <dd class="youtube">
                            <a
                              class="picto"
                              title="Nordnet sur Youtube"
                              id="footer-youtube"
                              href="https://www.youtube.com/c/nordnet"
                              target="_blank"
                              rel="noopener"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 15 10"
                                fill="none"
                              >
                                <title>Nordnet sur Youtube</title>
                                <path
                                  d="M14.5194 2.5379C14.5194 2.5379 14.384 1.64937 13.9669 1.25559C13.4416 0.740652 12.8513 0.740652 12.575 0.710361C10.6416 0.579102 7.73319 0.579102 7.73319 0.579102C7.73319 0.579102 4.82483 0.579102 2.8805 0.710361C2.60971 0.740652 2.01937 0.740652 1.48861 1.25559C1.07699 1.64937 0.941596 2.5379 0.941596 2.5379C0.941596 2.5379 0.800781 3.58798 0.800781 4.63301V5.61241C0.800781 6.65744 0.941596 7.70247 0.941596 7.70247C0.941596 7.70247 1.07699 8.591 1.49402 8.98478C2.01937 9.49972 2.71261 9.48458 3.02132 9.53506C4.13159 9.63603 7.73319 9.66632 7.73319 9.66632C7.73319 9.66632 10.647 9.66127 12.5859 9.53001C12.8567 9.49972 13.447 9.49972 13.9778 8.98478C14.3948 8.591 14.5302 7.70247 14.5302 7.70247C14.5302 7.70247 14.671 6.65744 14.671 5.61241V4.63301C14.6602 3.58798 14.5194 2.5379 14.5194 2.5379ZM6.30338 6.7988V3.16896L10.0512 4.99145L6.30338 6.7988Z"
                                  fill="#BEBEBE"
                                />
                              </svg>
                            </a>
                          </dd>
                        </dl>
                      </div>
                      <div class="footer-category">
                        <ul class="category">
                          <li class="category-item mobile-visible">
                            <a
                              class="link"
                              title="Conditions contractuelles"
                              id="footer-conditions-contractuelles"
                              href="${this
                                .baseUrl}/corporate/conditions-contractuelles"
                            >
                              Conditions contractuelles
                            </a>
                          </li>
                          <li class="category-item mobile-visible">
                            <a
                              class="link"
                              title="Récapitulatifs Contractuels"
                              id="footer-recapitulatif-contractuel"
                              href="${this
                                .baseUrl}/corporate/recapitulatif-contractuel"
                            >
                              Récapitulatifs Contractuels
                            </a>
                          </li>
                          <li class="category-item mobile-visible">
                            <a
                              class="link"
                              title="Règlement Parrainage"
                              id="footer-reglement-parrainage"
                              href="${this.baseUrl}/pdf/reglement-parrainage"
                            >
                              Règlement Parrainage
                            </a>
                          </li>
                          <li class="category-item mobile-visible">
                            <a
                              class="link "
                              title="Découvrez les fichiers produits des solutions Nordnet"
                              id="footer-documentation-produits"
                              href="${this.baseUrl}/documentation"
                            >
                              Documentations produits
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              id="footer-carte-couverture"
                              title="Carte de couverture technologies Haut-Débit"
                              href="${this
                                .baseUrl}/carte-technologies-haut-debit"
                            >
                              Carte de couverture Haut-Débit
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              title="Médiateur des communications électroniques"
                              id="footer-mediateur-communications-electroniques"
                              href="${this
                                .baseUrl}/corporate/mediateur-communications-electroniques"
                            >
                              Médiateur des communications électroniques
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              title="Protection de l’enfance"
                              id="footer-protection-enfance"
                              href="${this
                                .baseUrl}/corporate/protection-enfance"
                            >
                              Protection de l’enfance
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              title="Notification de contenus illicites"
                              id="footer-contenus-illicites"
                              href="${this.baseUrl}/corporate/contenu-illicite"
                            >
                              Notification de contenus illicites
                            </a>
                          </li>
                        </ul>
                        <ul class="category">
                          <li class="category-item">
                            <a
                              class="link"
                              id="footer-formulaire-retractation"
                              rel="nofollow"
                              title="Formulaire de rétractation"
                              target="_blank"
                              href="${this.baseUrl}/pdf/formulaire-retractation"
                            >
                              Formulaire de rétractation
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              title="Données personnelles"
                              id="footer-donnees-personnelles"
                              href="${this.baseUrl}/pdf/donnees-personnelles"
                              target="_blank"
                              rel="noopener"
                            >
                              Données personnelles
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              title="Polique de Cookies"
                              id="footer-politique-cookies"
                              href="${this.baseUrl}/politique-cookies"
                            >
                              Politique de Cookies
                            </a>
                          </li>
                          <li class="category-item mobile-visible">
                            <a
                              class="link"
                              title="Gérer les Cookies"
                              id="footer-manage-cookies"
                              href="${this.didomiUrl}"
                            >
                              Gérer les Cookies
                            </a>
                          </li>
                          <li class="category-item">
                            <a
                              class="link"
                              title="Plan du site"
                              id="footer-plan-site"
                              href="${this.baseUrl}/corporate/plan-du-site"
                            >
                              Plan du site
                            </a>
                          </li>
                          <li class="category-item mobile-visible">
                            <a
                              class="link"
                              title="Informations légales"
                              id="footer-informations-legales"
                              href="${this
                                .baseUrl}/corporate/informations-legales"
                            >
                              Informations légales
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}
